import React from 'react'
import s from './Header.module.scss'
import headerLogo from '../../assets/main/header.svg'
import button from '../../assets/SignIn/ButtonBack.png'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { HeaderDropDownMenu } from './HeaderDropDown/HeaderDropDown'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../store/authSlice'
import { SelectLanguage } from '../SelectLanguage/SelectLanguage'
import { useTranslation } from 'react-i18next'
import { HeaderDropDownMenuMain } from './HeaderDropDownMain/HeaderDropDownMain'
export const Header = () => {
    const dispatch = useDispatch()
    const { isAuth } = useSelector(state => state.auth)
    const { is_staff } = useSelector(state => state.auth)
    const { t } = useTranslation()
    const locate = useLocation()
    const path = locate.pathname
    const navigate = useNavigate()
    const goBack = () => navigate(-1)

    const navbar = () => {
        switch (path) {

            case '/userrecognition':
            case '/collectiontable':
            case '/deletetable':
            case '/newfilestable':
            // case '/statisticstable':
            case '/soundtraps': {
                return (
                    <HeaderDropDownMenu />
                )
            }
            case '/settingspage':
            case '/tableadd': {
                return (
                    <div className={s.header__right_block_button}>
                        <NavLink onClick={goBack}><div className={s.header_text}><span>{t('back')}</span></div><img src={button} alt="" /></NavLink>
                    </div>
                )
            }
            default: {
                return (
                    isAuth ? <div style={{marginTop: '0'}} className={s.header__button}>
                            {/* <button onClick={() => dispatch(logout())} className={s.button__up}>{t('logout')}</button> */}
                            <HeaderDropDownMenuMain />
                        </div>: <div className={s.header__button}>
                        <NavLink to='/signup'><button className={s.button__up}>
                            {t('signUp')}
                            </button></NavLink>
                        <NavLink to='/signin'><button className={s.button__in}>
                            {t('signIn')}
                            </button></NavLink>
                    </div>
                )
            }
        }
    }

    return (
        <div className={s.header__container}>
            <div className={s.header__body}>
                <div className={s.header__logo}>
                    <NavLink to='/'><img src={headerLogo} alt="#" /></NavLink>
                </div>
                <div className={s.header__right_block}>
                    <SelectLanguage />
                    {navbar()}
                </div>
            </div>
        </div>
    )
}